import { render, staticRenderFns } from "./FaqCategory.vue?vue&type=template&id=3f291493"
import script from "./FaqCategory.vue?vue&type=script&lang=js"
export * from "./FaqCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f291493')) {
      api.createRecord('3f291493', component.options)
    } else {
      api.reload('3f291493', component.options)
    }
    module.hot.accept("./FaqCategory.vue?vue&type=template&id=3f291493", function () {
      api.rerender('3f291493', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/FaqCategory.vue"
export default component.exports